// ============================================
// RYSMIDE — STICKY ADD TO CART
// CSS + JS in one file — injected via custom.js
// ============================================
(function () {
  'use strict';

  // --- Inject CSS ---
  var _css = '#stickyAddToCart{position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#fff;border-top:2px solid #E8E0D5;padding:12px 16px;transform:translateY(100%);transition:transform .3s cubic-bezier(.4,0,.2,1);will-change:transform}#stickyAddToCart.is-visible{transform:translateY(0)!important}.sticky-atc__inner{display:flex;align-items:center;justify-content:space-between;gap:12px;max-width:600px;margin:0 auto}.sticky-atc__info{display:flex;flex-direction:column;gap:3px;flex:1;min-width:0}.sticky-atc__name{font-family:Inter,sans-serif;font-weight:600;font-size:14px;color:#14201F;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.2}.sticky-atc__price{font-family:Inter,sans-serif;font-size:14px;font-weight:700;color:#14201F;line-height:1}.sticky-atc__price s{font-weight:400;color:#999;text-decoration:line-through;margin-right:4px}#stickyAddToCart .sticky-add-to-cart__button{background:var(--global-button-bg-color,#EF4A65)!important;color:var(--global-button-text-color,#fff)!important;border:none!important;border-radius:var(--global-button-radius,8px)!important;padding:14px 28px!important;font-family:Inter,sans-serif!important;font-weight:700!important;font-size:15px!important;cursor:pointer!important;white-space:nowrap!important;flex-shrink:0!important;letter-spacing:0!important;line-height:1!important;display:inline-flex!important;align-items:center!important}#stickyAddToCart .sticky-add-to-cart__button:hover{opacity:.9!important}#stickyAddToCart .sticky-add-to-cart__button:disabled{opacity:.6!important;cursor:not-allowed!important}@media(max-width:500px){#stickyAddToCart{padding:10px 12px}.sticky-atc__inner{gap:8px}#stickyAddToCart .sticky-add-to-cart__button{padding:13px 18px!important;font-size:14px!important}}';
  var styleTag = document.createElement('style');
  styleTag.id = 'sticky-atc-styles';
  styleTag.textContent = _css;
  document.head.appendChild(styleTag);

  // --- Init sticky bar ---
  function initStickyATC() {
    var ywp = document.getElementById('ywp');
    if (!ywp) return;
    var mainBtn = ywp.querySelector('[data-yw-atc]');
    if (!mainBtn) return;
    if (document.getElementById('stickyAddToCart')) return; // Prevent duplicate

    var bar = document.createElement('div');
    bar.id = 'stickyAddToCart';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="sticky-atc__inner">' +
        '<div class="sticky-atc__info">' +
          '<span class="sticky-atc__name">Rysmide Hair Growth Bar</span>' +
          '<span class="sticky-atc__price" id="stickyAtcPrice"></span>' +
        '</div>' +
        '<button type="button" class="sticky-add-to-cart__button" id="stickyAtcBtn">' +
          'Add to Cart' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);

    var stickyBtn = document.getElementById('stickyAtcBtn');

    // Sync price display from active offer
    function syncPrice() {
      var active = ywp.querySelector('.ywp-offer.is-active');
      if (!active) return;
      var priceEl = document.getElementById('stickyAtcPrice');
      if (!priceEl) return;
      var nowEl = active.querySelector('[data-yw-now]');
      var wasEl = active.querySelector('[data-yw-was]');
      if (nowEl) {
        var wasText = (wasEl && wasEl.textContent.trim()) ? '<s>' + wasEl.textContent.trim() + '</s> ' : '';
        priceEl.innerHTML = wasText + nowEl.textContent.trim();
      } else if (active.dataset.price) {
        priceEl.textContent = active.dataset.price;
      }
    }

    // Show/hide based on main ATC button position
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = mainBtn.getBoundingClientRect();
        var hidden = rect.bottom < 0 || rect.top > window.innerHeight;
        bar.classList[hidden ? 'add' : 'remove']('is-visible');
        bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        ticking = false;
      });
    }

    // Update when user selects a different offer
    ywp.addEventListener('click', function (e) {
      if (e.target.closest('[data-yw-offer]')) setTimeout(syncPrice, 60);
    });

    // Click handler — mirrors the YW form submit logic
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var active = ywp.querySelector('.ywp-offer.is-active') || ywp.querySelector('[data-yw-offer]');
        if (!active) return;
        var giftsInput = active.querySelector('[data-yw-gifts]');
        var variantId = +active.dataset.variant;
        if (!variantId) return;
        var item = { id: variantId, quantity: 1 };
        if (giftsInput && giftsInput.value) item.properties = { 'Free gifts': giftsInput.value };

        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) throw r;
          window.location.href = '/cart';
        }).catch(function () {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'Add to Cart';
        });
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    syncPrice();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();
// ============================================
// END STICKY ADD TO CART
// ============================================
